import OapRegisterNowPopup from './code/Scripts/components/OapRegisterNowPopup.vue';

export default {
  components: {
    OapRegisterNowPopup,
  },
};
